import { render } from "./ViewClient.vue?vue&type=template&id=6d106827&scoped=true&ts=true"
import script from "./ViewClient.vue?vue&type=script&lang=ts"
export * from "./ViewClient.vue?vue&type=script&lang=ts"

import "./ViewClient.vue?vue&type=style&index=0&id=6d106827&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d106827"]])

export default __exports__